module.exports = __webpack_public_path__ + "static/media/puce.7041a777.png";